module.exports = __webpack_public_path__ + "img/home_employers_mobile.f9b412ea.jpg";